// eslint-disable-next-line import/named
import i18next from 'i18next';

import slide1 from './img/slide1.webp';
import slide2_de from './img/slide2_de.webp';
import slide2_en from './img/slide2_en.webp';
import slide2_es from './img/slide2_es.webp';
import slide2_fr from './img/slide2_fr.webp';
import slide2_it from './img/slide2_it.webp';
import slide2_pt from './img/slide2_pt.webp';
import slide3_de from './img/slide3_de.webp';
import slide3_en from './img/slide3_en.webp';
import slide3_es from './img/slide3_es.webp';
import slide3_fr from './img/slide3_fr.webp';
import slide3_it from './img/slide3_it.webp';
import slide3_pt from './img/slide3_pt.webp';
import slide4_de from './img/slide4_de.webp';
import slide4_en from './img/slide4_en.webp';
import slide4_es from './img/slide4_es.webp';
import slide4_fr from './img/slide4_fr.webp';
import slide4_it from './img/slide4_it.webp';
import slide4_pt from './img/slide4_pt.webp';

const localizedImages: Record<string, Record<string, string>> = {
    slide2: {
        en: slide2_en,
        fr: slide2_fr,
        de: slide2_de,
        es: slide2_es,
        pt: slide2_pt,
        it: slide2_it,
    },
    slide3: {
        en: slide3_en,
        fr: slide3_fr,
        de: slide3_de,
        es: slide3_es,
        pt: slide3_pt,
        it: slide3_it,
    },
    slide4: {
        en: slide4_en,
        fr: slide4_fr,
        de: slide4_de,
        es: slide4_es,
        pt: slide4_pt,
        it: slide4_it,
    },
};

export const getSliderConfig = () => {
    const lang = i18next.language || 'en';

    return [
        {
            img: slide1,
            title: 'subscription.freeMonthModalNew.slider.title1',
            description: 'subscription.freeMonthModalNew.slider.description1',
        },
        {
            img: localizedImages.slide2[lang],
            title: 'subscription.freeMonthModalNew.slider.title2',
            description: 'subscription.freeMonthModalNew.slider.description2',
        },
        {
            img: localizedImages.slide3[lang],
            title: 'subscription.freeMonthModalNew.slider.title3',
            description: 'subscription.freeMonthModalNew.slider.description3',
        },
        {
            img: localizedImages.slide4[lang],
            title: 'subscription.freeMonthModalNew.slider.title4',
            description: 'subscription.freeMonthModalNew.slider.description4',
        },
    ];
};
